export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 pb-5 border-b border-zinc-900">
      <div>
        <h1 className="text-2xl font-bold tracking-tight" data-testid="page-title">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-zinc-500 mt-1" data-testid="page-subtitle">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
